import { render, staticRenderFns } from "./CompanyPublic.vue?vue&type=template&id=168b4019&"
import script from "./CompanyPublic.vue?vue&type=script&lang=js&"
export * from "./CompanyPublic.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPublic.vue?vue&type=style&index=0&id=168b4019&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports